import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import Access from "../../CustomComponents/Access/Access";
import { useDispatch, useSelector } from "react-redux";
import { getSettings } from "../../../redux/Contacts/action";
import whatsappIcon from "../../../assests/imgs/whatsapp-icon.svg"

export default function PublicFooter() {
  const path = "Assets/scss/footer.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [modal, setModal] = useState(false);
  const laung = localStorage.getItem("laung") ?? "en";
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  const theSettingDetails = useSelector(
    ({ settingsDetails: { settingList } }) => settingList || {}
  );

  const {
    facebook,
    twitter,
    instagram,
    youtube,
    snapchat,
    app_store,
    play_store,
    privacy_policy,
    terms_condition,
    faq,
    whatsapp_call,
  } = theSettingDetails;

  console.log("theSettingDetails", theSettingDetails);
  const whatsAppHref = whatsapp_call
    ? `https://wa.me/${whatsapp_call}?text=${encodeURIComponent('Hello I need assistance.')}`
    : '#';
  const privacyPolicyPath = `/${laung}/privacy-policy`;
  const termsConditionsPath = `/${laung}/terms-and-conditions`;

  return (
    <div className="container-fluid footer">
      {modal && (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${laung}/submitprojectproposal`}
          state={"state"}
          checkpermission={"bid_project"}
        />
      )}

      <div className="footer-first">
        <div className="footer-top">
          <div className="row footer-mobile-row">
            {/* For Users */}
            <div className="col-md-3 col-6">
              <h6>For Users</h6>
              <div className="footer-menu">
                <a onClick={() => navigate(`/${laung}/createpost`, { state: { theType: 1 } })}>Create a Post</a>
                <a onClick={() => navigate(`/${laung}/searchpackaged`)}>Buy one time service (OTS)</a>
                <a onClick={() => navigate(`/${laung}/hireexpertsmainpage`)}>Hire Experts</a>
                <a onClick={() => navigate(`/${laung}/searchrentproducts`)}>Rent on Urxprt</a>
                <a onClick={() => navigate(`/${laung}/searchauction`)}>Auctions</a>
                {/* <a href={faq || "#"} target="_blank" rel="noopener noreferrer">FAQ’s</a>
                <a onClick={() => navigate(`/${laung}`)}>How it works</a>
                <a onClick={() => navigate(`/${laung}`)}>Why choose us</a> */}
              </div>
            </div>

            {/* For Experts */}
            <div className="col-md-3 col-6">
              <h6>For Experts</h6>
              <div className="footer-menu">
                <a onClick={() => navigate(`/${laung}/searchall`)}>Find work/projects</a>
                <a onClick={() => navigate(`/${laung}/dashboard/myotsproducts`)}>
                  Create one time service (OTS)
                </a>
                <a onClick={() => navigate(`/${laung}/searchall?type=${2}`)}>Open contests</a>
                <a onClick={() => navigate(`/${laung}/account/upgrademembership`)}>
                  Upgrade membership
                </a>
                {/* <a onClick={() => navigate(`/${laung}/searchbuyproducts`)}>Sell on Urxprt</a>
                <a onClick={() => navigate(`/${laung}/searchdownloadcv`)}>Rent resources</a> */}
                {/* <a onClick={() => navigate(`/${laung}`)}>Payment terms</a>
                <a href={faq || "#"} target="_blank" rel="noopener noreferrer">FAQ’s</a> */}
              </div>
            </div>

            {/* Resources */}
            <div className="col-md-3 col-6">
              <h6>Resources</h6>
              <div className="footer-menu">
                {/* <a onClick={() => navigate(`/${laung}`)}>Help & support</a> */}
                {/* <a onClick={() => navigate(`/${laung}`)}>Resources</a>
                <a onClick={() => navigate(`/${laung}`)}>Community</a>
                <a onClick={() => navigate(`/${laung}`)}>Become a partner</a>
                <a onClick={() => navigate(`/${laung}`)}>About Urxprt</a> */}
                {/* <a onClick={() => navigate(`/${laung}/contact_us`)}>Contact us</a> */}
                <a onClick={() => navigate(`/${laung}/searchbuyproducts`)}>Sell on Urxprt</a>
                <a onClick={() => navigate(`/${laung}/searchmergersacquisitions`)}>Merger & Acquisition Services</a>
              </div>
            </div>

            {/* Company */}
            <div className="col-md-3 col-6">
              <h6>Company</h6>
              <div className="footer-menu">
                <a onClick={() => navigate(`/${laung}/contact_us`)}>Contact us</a>
                {/* <a onClick={() => navigate(`/${laung}`)}>Career</a> */}
                <a href={app_store || "#"} target="_blank" rel="noopener noreferrer">
                  Download App (iOS)
                </a>
                <a href={play_store || "#"} target="_blank" rel="noopener noreferrer">
                  Download App (Android)
                </a>
              </div>
            </div>
          </div>

          {/* Socials */}
          <div className="footer-second foot-2">
            <a onClick={() => navigate(`/${laung}`)}>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/footer-logo.svg`}
                className="w-100"
                alt="footer logo"
              />
            </a>
            <div className="footer-right">
              <p>Follow us</p>
              <div className="shares">
                {facebook && (
                  <a href={facebook} target="_blank" rel="noopener noreferrer">
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/facebook.svg`}
                      alt="facebook"
                    />
                  </a>
                )}
                {twitter && (
                  <a href={twitter} target="_blank" rel="noopener noreferrer">
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/Twitter.svg`}
                      alt="twitter"
                    />
                  </a>
                )}
                {instagram && (
                  <a href={instagram} target="_blank" rel="noopener noreferrer">
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/Insta.svg`}
                      alt="instagram"
                    />
                  </a>
                )}
                {youtube && (
                  <a href={youtube} target="_blank" rel="noopener noreferrer">
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/Linkedin.svg`}
                      alt="youtube"
                    />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-second foot-3">
          <p>© 2026 Urxprt.com. All rights reserved.</p>
          <div className="terms-condition">
            <a
              href={privacyPolicyPath}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <a
              href={termsConditionsPath}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
